import { i18n } from '@fides/fides-react-components';

import translationDE from './de.json';
import translationEN from './en.json';
import translationES from './es.json';
import translationFR from './fr.json';
import translationIT from './it.json';

i18n.setDefaultNamespace('dlc');
i18n.addResourceBundle('de', 'dlc', translationDE);
i18n.addResourceBundle('en', 'dlc', translationEN);
i18n.addResourceBundle('es', 'dlc', translationES);
i18n.addResourceBundle('fr', 'dlc', translationFR);
i18n.addResourceBundle('it', 'dlc', translationIT);

export default i18n;